import actionTypes from "../actionTypes";
import config from "../../config";

export const loginRedirect = () => ({
  type: actionTypes.app.LOGIN_ATTEMPT
});

export const softLogout = () => ({
  type: actionTypes.app.LOGOUT
});

export const logout = () => ({
  type: actionTypes.app.API_FETCH,
  start: actionTypes.app.LOGOUT,
  url: config.api.authUrl + "/logout",
  options: {
    credentials: "include",
    method: "POST"
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/Authentication.js